import React, { useEffect, useState } from "react";
import { Container, ChildContainer } from "../../../components/Container/Containers";
import NewService from "../add/newService.container";

import BannerImage from "../bannerImage/BannerImage";
import { Breadcrumbs } from "../../../components/breadcrumbs/Breadcrumbs";
import { Tabs } from "../../../components/tabs/Tabs";
import { MY_SERVICE_TABS, subTabs } from "../../../utils/constants/serviceConstants";
import LiveServices from "../../liveServices/liveServices.container";
import SectionGuard from "../../../hoc/guards/SectionGuard";
import CAN from '../../../casl/can';
import { Action, Resource } from '../../../casl/constants';
import { USER_TYPE } from "../../../utils/constants/userConstants";
import NewRequestViewerContainer from "./newRequestViewer/NewRequestViewer.container";
import {connect} from "react-redux";
import { openNewServiceForm,closeNewServiceForm,setServiceActiveTab,setIsAmendMode } from "../../../redux/actions/newService/service.actions";
import { NotificationOptions } from "../../../redux/actions/notification/getEventNotificationList.action";
import { getModuleNotification } from "../../../redux/actions/notification/getModuleNotification.action";
import { TAB } from "../../../utils/constants/homeConstants";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";


const ServicesViewer = (props) => {
  let _label=props.myRights?.userType==USER_TYPE.INTERNAL?"Connectivity":"My Connectivity";
  const params= useParams();
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const subRoute = pathParts[2];
  const navigate = useNavigate();
  const [paramData,setParamData] = useState({})
  let demandParam = null;
  useEffect(()=>{
    if(params.hasOwnProperty('data')){
      demandParam = JSON.parse(params.data);
      if(demandParam?.tab===TAB.DEMANDS){
        props?.setServiceActiveTab(TAB.DEMANDS)
      }
      setParamData(demandParam)
    }
  },[])
  const breadcrumbsOption = [
    { label: "Home", link: "/dashboard" },
    { label: _label, link: "" }
  ];
 // const [activeTab, setActiveTab] = useState("");
  //const [tabOptions, setTabOptions] = useState([]);
  const [bannerTitle, setBannerTitle] = useState();

  // let demandTabName=props.myRights?.userType==USER_TYPE.INTERNAL?MY_SERVICE_TABS.DEMANDS:MY_SERVICE_TABS.MY_DEMANDS // dynamic tab name

  // if(CAN(Action.LIST, Resource.DEMANDS) && CAN(Action.LIST, Resource.LIVE_SERVICES)){
  //   setTabOptions([MY_SERVICE_TABS.LIVE_SERVICES, demandTabName]);
  // }else if(CAN(Action.LIST, Resource.LIVE_SERVICES)){
  //   props.setServiceActiveTab(MY_SERVICE_TABS.LIVE_SERVICES);
  // }else if(CAN(Action.LIST, Resource.DEMANDS)){
  //   props.setServiceActiveTab(MY_SERVICE_TABS.demandTabName);
  // }

  //let demandTabName = props.myRights?.userType === USER_TYPE.INTERNAL ? MY_SERVICE_TABS.DEMANDS : MY_SERVICE_TABS.MY_DEMANDS;
  let Demandcount = props?.notifications?.data?.DEMANDS_MODULE?.length  
  let tabOptions = [
    {
      key: MY_SERVICE_TABS.LIVE_SERVICES,
      label: "Live Services",
      canAccess: CAN(Action.LIST, Resource.LIVE_SERVICES),
      routeUrl:'/connectivity/liveServices'
      // count:"4"
    },
    {
      key: MY_SERVICE_TABS.DEMANDS,
      label: props.myRights?.userType==USER_TYPE.INTERNAL? "Demands" : "My Demands",
      canAccess: CAN(Action.LIST, Resource.DEMANDS),
      count:Demandcount,
      routeUrl:'/connectivity/demands'
    },
  ];

  const getActiveTab = (tab) => {
    props.setServiceActiveTab(tab);
    props.NotificationOptions();
    props.getModuleNotification();
  }
  let [initialValues, setInitialValues] = useState({});


  const newServiceRequest = () => {
    setInitialValues({}); // open blank form
    props.setIsAmendMode(false); //     
    props.openNewServiceForm({});
  }

  useEffect(()=>{

      if(CAN(Action.LIST, Resource.DEMANDS) && CAN(Action.LIST, Resource.LIVE_SERVICES)){
        let title=props.myRights?.userType==USER_TYPE.INTERNAL? "Connectivity" : "My Connectivity";
        setBannerTitle(title)
      }else if(CAN(Action.LIST, Resource.LIVE_SERVICES) && !CAN(Action.LIST, Resource.DEMANDS)){
        setBannerTitle("Live Services")

      }else if(CAN(Action.LIST, Resource.DEMANDS) && !CAN(Action.LIST, Resource.LIVE_SERVICES)){
        let title=props.myRights?.userType==USER_TYPE.INTERNAL? "Demands" : "My Demands";
        setBannerTitle(title)
      }
  },[])

  const getConnectivityAccess = (subRoute) => {
    const canAccessLiveServices = CAN(Action.LIST, Resource.LIVE_SERVICES);
    const canAccessDemands = CAN(Action.GET, Resource.DEMANDS);
    if(subRoute === "liveServices"){
      return canAccessLiveServices;
    }else if(subRoute === "demands"){
      return canAccessDemands;
    }else if(subRoute === "demandToCash"){
      return canAccessDemands;
    }
  };

  return (
    <Container>
      {/* <div style={getConnectivityAccess(subRoute)&&{margin:"auto"}}>
      </div> */}
     {getConnectivityAccess(subRoute)&&
      <>
      <BannerImage bannerTitle={bannerTitle} isInternalUser={props.myRights?.userType==USER_TYPE.INTERNAL?true:false} showPopup="true" openForm={newServiceRequest} canCreateNewService={CAN(Action.CREATE, Resource.DEMANDS)} isAmendMode={props.isAmendMode}/>
   
    
      {/* <ChildContainer>
        <Breadcrumbs options={breadcrumbsOption} />
      </ChildContainer> */}
      {
        CAN(Action.LIST, Resource.DEMANDS) && CAN(Action.LIST, Resource.LIVE_SERVICES) ?
       <Tabs option={tabOptions} defaultActiveTab={subTabs[subRoute]} getActiveTab={getActiveTab} />:<></>
      }
        <NewService initialValue={initialValues} fromLiveService={false}></NewService>
        </>
     }
      <ChildContainer>
        {/* {
           props.serviceActiveTab === MY_SERVICE_TABS.DEMANDS ?
            <NewRequestViewerContainer demandParamData={paramData}/> :
            props.serviceActiveTab === MY_SERVICE_TABS.LIVE_SERVICES ?
            <LiveServices />:<></>
        } */}
        <Outlet/>
      </ChildContainer>
    </Container>
  )
};
const mapStateToProps = (state) => {    
  return {
    notifications: state.notifications.moduleNotification.data,
    serviceActiveTab:state.newService.service.serviceActiveTab,
    myRights:state.myRights.myRights,
    isAmendMode:state.newService.service.isAmendMode
  }
}

const mapDispatchToProps = (dispatch)=>{
  return {
      openNewServiceForm: (payload) => {
          return dispatch(openNewServiceForm(payload))
      },
      closeNewServiceForm: () => {
          return dispatch(closeNewServiceForm())
      },
      setServiceActiveTab: (tab) => {
        return dispatch(setServiceActiveTab(tab))
      },
      setIsAmendMode: (mode) => {
        return dispatch(setIsAmendMode(mode))
      },
      NotificationOptions: () => {
        return dispatch(NotificationOptions())
      },
      getModuleNotification: () => {
        return dispatch(getModuleNotification())
      }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicesViewer);